import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

// Define an interface for the config structure
export interface DynamicConfig {
    homeUrl: string;
    // Add other configuration options as needed
}

// Declare the global APP_CONFIG
declare global {
    interface Window {
        APP_CONFIG?: Partial<DynamicConfig>;
    }
}

@Injectable({
    providedIn: 'root',
})
export class DynamicConfigService {
    private config: DynamicConfig;

    constructor() {
        // Initialize with environment values (build-time configuration)
        this.config = {
            homeUrl: environment.homeUrl,
            // Add other properties from environment as needed
        };

        // Always override with window.APP_CONFIG values if they exist, regardless of environment
        if (window.APP_CONFIG) {
            // Override homeUrl if defined in runtime config
            if (
                window.APP_CONFIG.homeUrl !== undefined &&
                window.APP_CONFIG.homeUrl !== null
            ) {
                this.config.homeUrl = window.APP_CONFIG.homeUrl;
            }

            // Add overrides for other properties as needed
        } else {
            console.log('Dynamic Config not loaded');
        }

        console.log(
            'DynamicConfigService initialized with config:',
            this.config
        );
    }

    get homeUrl(): string {
        return this.config.homeUrl;
    }

    // Add other getters as needed
}
